import{a as n}from"./chunk-RAAYCPUM.js";function m(...r){return n(o,r)}function o(r,t){let e=[...r];return e.sort(t),e}export{m as a};
